import BaseStore from "@/stateManagement/BaseStore";
import { StoreConfig } from "@datorama/akita";
import { singleton } from "tsyringe";

import { ReviewsSummaryEntity } from "../entities/ReviewsSummaryEntity";

export type ReviewsSummaryState = {
    summary: ReviewsSummaryEntity | null;
};

function createInitialState() {
    return {
        summary: null,
    };
}

@singleton()
@StoreConfig({ name: "ReviewsSummaryStore" })
class ReviewsSummaryStore extends BaseStore<ReviewsSummaryState> {
    constructor() {
        super(createInitialState());
    }
}

export default ReviewsSummaryStore;
